module.exports = __webpack_public_path__ + "img/worry-fukidashi-pc.0fc7c04.png";